/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://zjgay6l1s0.execute-api.eu-central-1.amazonaws.com/staging",
            "region": "eu-central-1"
        },
        {
            "name": "CompanyAdminQueries",
            "endpoint": "https://x6axn0pofe.execute-api.eu-central-1.amazonaws.com/staging",
            "region": "eu-central-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-central-1:35071f35-0847-4cce-97b8-91a362eb0b29",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_k3YJ3UqfB",
    "aws_user_pools_web_client_id": "32ao5aeoeslh7hdsgm4d134u1p",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "FAMILY_NAME",
        "GIVEN_NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "images155638-staging",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
